import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { getBannerPreviewUrl } from '@/entities/meta/lib/bannerPreviewUrl';
import { getRecommendedBannerTextLength } from '@/entities/meta/lib/recommendedBannerTextLength';
import { safeT } from '@/shared/localization';
import { useLocale, useTranslations } from 'next-intl';
import { useMetadata } from './useMetaData';
export default function useBannerMeta() {
  const $ = _c(23);
  const t = useTranslations("meta");
  const locale = useLocale();
  const {
    data: t0
  } = useMetadata();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      banner: {
        templates: [],
        backgrounds: [],
        ratios: []
      }
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const meta = t1;
  let t2;
  if ($[2] !== locale || $[3] !== meta.banner.templates || $[4] !== t) {
    let t3;
    if ($[6] !== locale || $[7] !== t) {
      t3 = template => {
        const recommended = getRecommendedBannerTextLength(template.key);
        return {
          ...template,
          maxMainTextLength: recommended.main,
          maxSubTextLength: recommended.sub,
          label: safeT(t, template.displayKey, template.displayKey),
          value: template.key,
          thumbnail: getBannerPreviewUrl(locale, template.key, "1:1")
        };
      };
      $[6] = locale;
      $[7] = t;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = meta.banner.templates.map(t3);
    $[2] = locale;
    $[3] = meta.banner.templates;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const templates = t2;
  let t3;
  if ($[9] !== meta.banner.backgrounds || $[10] !== t) {
    let t4;
    if ($[12] !== t) {
      t4 = background => ({
        label: safeT(t, background.displayKey, background.displayKey),
        value: background.key,
        thumbnail: `/banner-presets/background/${background.key}.webp`
      });
      $[12] = t;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    t3 = meta.banner.backgrounds.map(t4);
    $[9] = meta.banner.backgrounds;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const backgrounds = t3;
  let t4;
  if ($[14] !== meta.banner.ratios || $[15] !== t) {
    let t5;
    if ($[17] !== t) {
      t5 = ratio => ({
        label: `${safeT(t, ratio.displayKey, ratio.displayKey)} (${ratio.width} x ${ratio.height})`,
        value: ratio.ratio
      });
      $[17] = t;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    t4 = meta.banner.ratios.map(t5);
    $[14] = meta.banner.ratios;
    $[15] = t;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const ratios = t4;
  let t5;
  if ($[19] !== backgrounds || $[20] !== ratios || $[21] !== templates) {
    t5 = {
      templates,
      backgrounds,
      ratios
    };
    $[19] = backgrounds;
    $[20] = ratios;
    $[21] = templates;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
}